import React, { useCallback, useEffect, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { setHarvestingContentView } from 'redux/reducers/synchrotronTripReducer';
import { useAssignCryoToCrystals, useCryoAgents } from './hooks';
import SelectAgents from './selectAgents';

const SelectCryo = () => {
  const dispatch = useRMDispatch();
  const cryoAgents = useCryoAgents();
  const [cryoList, setCryoList] = useState([]);
  const applyCryo = useAssignCryoToCrystals(
    cryoList?.filter((x) => x.checked)?.map((x) => x.id),
  );

  useEffect(() => {
    if (cryoAgents?.length) {
      setCryoList(cryoAgents);
    } else {
      setCryoList([]);
    }
  }, [cryoAgents]);

  const onSelectCryo = (id: number) => {
    setCryoList(
      cryoList?.map((cryo) => {
        if (cryo.id === id) {
          return { ...cryo, checked: !cryo.checked };
        }
        return cryo;
      }),
    );
  };

  const handleBackToPreviousScreen = useCallback(
    (contentView) => () => {
      dispatch(setHarvestingContentView(contentView));
    },
    [],
  );

  return (
    <SelectAgents
      id={`exp-selectagents-cryo`}
      agentsList={cryoList}
      handleBackToPreviousScreen={handleBackToPreviousScreen}
      onSelectAgent={onSelectCryo}
      applyChanges={applyCryo}
    />
  );
};

export default SelectCryo;
